<template>
  <transition name="fade" @before-leave="beforeLeave" @after-leave="afterLeave">
    <div v-transfer-dom :data-transfer="transfer" class="modal-wrap" @click="close" v-show="visible">
      <div class="f-transform-center modal-box" :style="{width: width + 'px',paddingRight: paddingRight + 'px', paddingLeft: paddingLeft + 'px'}" @click.stop="stopPropagation">
        <span v-if="showClose" class="modal-close" @click.stop="close">
          <Icon type="ios-close" />
        </span>
        <slot name="header">
          <div class="modal-header f-center" :style="headerStyle">{{title}}</div>
        </slot>
        <slot name="body">
          <div class="modal-body f-center" :style="contentStyle">{{content}}</div>
        </slot>
        <slot name="footer">
          <div class="modal-footer f-fl-clear" v-if="showFooter">
            <button v-if="hasCancelBtn" class="f-fl-left footer-button" @click.stop="close">{{cancelText}}</button>
            <button v-if="hasConfirmBtn" class="f-fl-right footer-button" @click.stop="handleConfirm">{{confirmText}}</button>
          </div>
        </slot>
        <div class="blankBox" v-if="showBlankBox"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import TransferDom from '../select/transfer-dom'
export default {
  mame: 'AbModal',
  directives: {
    TransferDom
  },
  props: {
    showClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: [Number, String],
      default: 760
    },
    confirm: {
      type: Boolean,
      default: false
    },
    content: {
      type: String
    },
    contentStyle: {
      type: Object
    },
    title: {
      type: String
    },
    headerStyle: {
      type: Object
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    hasCancelBtn: {
      type: Boolean,
      default: true
    },
    hasConfirmBtn: {
      type: Boolean,
      default: true
    },
    paddingRight: {
      type: [Number, String]
    },
    paddingLeft: {
      type: [Number, String]
    },
    transfer: {
      type: Boolean
    },
    oneCenter: {
      type: Boolean
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: true,
      showBlankBox: false
    }
  },
  computed: {

  },
  methods: {
    close() {
      this.$emit('close')
    },
    stopPropagation() {
      return false
    },
    beforeLeave() {
      this.showBlankBox = true
    },
    afterLeave() {
      this.showBlankBox = false
      this.$emit('closed')
    },
    handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/function.scss';
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.modal-wrap {
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1300;
  .modal-box {
    padding: 42px 60px;
    background: $c-bg;
    border-radius: 8px;
    .modal-close {
      position: absolute;
      right: 8px;
      top: 8px;
      width: 42px;
      height: 42px;
      line-height: 42px;
      cursor: pointer;
      .ivu-icon {
        font-size: 42px;
        vertical-align: initial;
      }
    }
    .modal-header {
      font-size: 20px;
      font-weight: bold;
    }
    .modal-body {
      margin: 16px 0 24px 0;
      font-size: 12px;
    }
    .modal-footer {
      .footer-button {
        width: 94px;
        height: 32px;
        border: none;
        background: #ff7a45;
        border-radius: 4px;
        color: #ffffff;
        cursor: pointer;
      }
    }
    .blankBox {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
/deep/ .mt-8 {
  margin-top: 8px;
}
/deep/ .mt-24 {
  margin-top: 24px;
}
/deep/ .ml-8 {
  margin-left: 8px;
}
/deep/ .footer-button {
  width: 94px;
  height: 32px;
  border: none;
  background: #ff7a45;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
}
</style>
